import { formatCurrency } from '@/helpers/format';
import dayjs from 'dayjs';

interface IGroupedDates {
  groupedDates: any[];
  detailsFontSize: string;
  checkin?: string;
  checkout?: string;
}

const GroupDates = ({
  groupedDates,
  detailsFontSize,
  checkin,
  checkout,
}: IGroupedDates) => {
  const hoursDiff =
    checkin && checkout ? dayjs(checkout).diff(dayjs(checkin), 'hour') : 0;

  return (
    <>
      {groupedDates.length === 1 ? (
        <tr className={detailsFontSize}>
          {groupedDates[0]?.hours ? (
            <td>
              {dayjs(groupedDates[0].start).format('MMM DD')}{' '}
              <span>
                ({groupedDates[0].hours} hour
                {groupedDates[0].hours > 1 ? 's' : ''})
              </span>{' '}
              *
            </td>
          ) : (
            <td>
              {dayjs(checkin).isSame(dayjs(checkout), 'day') ? (
                <>
                  {dayjs(checkin).format('MMM DD')}{' '}
                  <span>
                    ({hoursDiff} hour{hoursDiff !== 1 ? 's' : ''})
                  </span>{' '}
                  *
                </>
              ) : (
                <>
                  {dayjs(groupedDates[0].start).format('MMM DD')} –{' '}
                  {dayjs(groupedDates[0].start)
                    .add(groupedDates[0].days, 'days')
                    .format('MMM DD')}{' '}
                  <span>({groupedDates[0].days} days)</span> *
                </>
              )}
            </td>
          )}
          <td className="text-right">
            {groupedDates[0].hours ? '' : groupedDates[0].days + ' x '}
            {formatCurrency({
              value: groupedDates[0].rate,
              locale: 'en-US',
              currency: 'USD',
            })}
          </td>
        </tr>
      ) : (
        groupedDates.map((date, index) => (
          <tr className={detailsFontSize} key={index}>
            {date.hours ? (
              <td>
                {dayjs(date.start).format('MMM DD')}{' '}
                <span>
                  ({date.hours} hour{date.hours > 1 ? 's' : ''}){' '}
                  {date.free ? 'Free' : ''}
                </span>{' '}
                *
              </td>
            ) : dayjs(date.start).isSame(dayjs(date.end)) ? (
              <td>
                {dayjs(date.start).format('MMM DD')}{' '}
                <span>(1 day) {date.free ? 'Free' : ''}</span> *
              </td>
            ) : (
              <td>
                {dayjs(date.start).format('MMM DD')} –{' '}
                {dayjs(date.end).format('MMM DD')}{' '}
                <span>
                  ({date.days} days) {date.free ? 'Free' : ''}
                </span>{' '}
                *
              </td>
            )}
            <td className="text-right">
              {date.hours ? '' : date.days + ' x '}
              {formatCurrency({
                value: date.rate,
                locale: 'en-US',
                currency: 'USD',
              })}
            </td>
          </tr>
        ))
      )}
    </>
  );
};
export default GroupDates;
